import validPath from 'is-valid-path';

import Analytics from '../../../analytics';
import config from 'config';

export default [
  '$scope', '$location', '$timeout', '$window', 'AuthService', 'UserDataService', 'ErrorHandler',
  class RegisterController {
    constructor($scope, $location, $timeout, $window, authService, userDataService, errorHandler, analytics = new Analytics()) {
      this._authService = authService;
      this._$scope = $scope;
      this._$location = $location;
      this._$window = $window;
      this._$timeout = $timeout;
      this._userDataService = userDataService;
      this._errorHandler = errorHandler;
      this.analytics = analytics;

      this.refId = this._$location.search()['r'];
      if (this.refId && typeof $window.localStorage !== 'undefined') $window.localStorage.setItem('referralCode', JSON.stringify({ refId: this.refId, time: new Date() }));

      $scope.$on('register:signUpEmail', (event, { email }) => {
        this.email = email;
      });

      this.grecaptchaInterval = setInterval(() => {
        if (this._$window.grecaptcha && this._$window.grecaptcha.render) {
          this.recaptchaId = this._$window.grecaptcha.render('google_recaptcha_register', {
            sitekey: config.GOOGLE_RECAPTCHA_SITEKEY,
            size: 'invisible',
            callback: token => this.register(token),
          });

          clearInterval(this.grecaptchaInterval);

          $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
        }
      }, 100);
    }

    submitRegistration(isValid) {
      if (isValid) this._$window.grecaptcha.execute(this.recaptchaId);
    }

    register(recaptchaToken) {
      this._$window.grecaptcha.reset(this.recaptchaId);

      this.submitState = 'loading';

      if (!this.refId && typeof this._$window.localStorage !== 'undefined') {
        try {
          let refObj = JSON.parse(this._$window.localStorage.getItem('referralCode'));
          if (Math.abs(new Date() - new Date(refObj.time)) / 36e5 <= 24) {
            this.refId = refObj.refId;
          }
        } catch (e) {}
      }

      this._authService.register(this.name, this.publicName, this.email, this.password, this.terms, this.refId, this.partnerId, recaptchaToken)
        .then((res) => this.registerSuccess(res))
        .catch((err) => this.registerError(err));

      if (typeof this._$window.localStorage !== 'undefined') this._$window.localStorage.removeItem('referralCode');
    }

    registerSuccess(res) {
      this.analytics.register();
      this.submitState = 'success';
      this.redirecting = true;
      this._userDataService.setUserData(res, true);

      let returnPath = this._$location.search().return,
        route = typeof returnPath == 'string' && validPath(returnPath.split('?')[0]) && returnPath.indexOf('/auth/shopify') === 0 ? returnPath.replace(/\\/g, '').replace('//', '') : '/client';

      if (route === '/client' && res.dashboard_link) {
        this._$window.location.href = res.dashboard_link;
      } else {
        this._$window.location.href = route;
      }
    }

    registerError(err) {
      this.submitState = 'error';
      this._errorHandler.throwError('Registration Error', err && err.data && err.data.message ? err.data.message : 'Error Registering, please try again.');
    }

    nameChanged() {
      this.publicName = this.name;
      this.formatPublicName();
    }

    validatePublicName() {
      if (this.timeout) {
        this._$timeout.cancel(this.timeout);
      }

      let name = this.publicName;
      //prefer timeout over debounce so format changes happen on key press.
      this.timeout = this._$timeout(() => {
        return this._authService.verifyPublicName(name);
      }, 500);

      return this.timeout;
    }

    formatPublicName() {
      this.publicName = this.publicName.toLowerCase();
      this.publicName = this.cleanPublicName();
    }

    cleanPublicName() {
      return this.publicName.replace(/\s/g, '-').replace(/([~!@#%^&*()"'+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '');
    }

    emailChanged() {
      if (this.emailTimeout) {
        this._$timeout.cancel(this.emailTimeout);
      }

      this.emailTimeout = this._$timeout(() => {
        return this._emailChangedHelper();
      }, 500);

      return this.emailTimeout;
    }

    _emailChangedHelper() {
      let promise = this._authService.verifyEmailAddress(this.email);

      promise.catch((err) => {
        this.emailError = err && err.data && err.data.message ? err.data.message : 'Invalid Email';
      });

      return promise;
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/account/register/register.ctrl.js